import { render, staticRenderFns } from "./FeesTables.vue?vue&type=template&id=8e84ad2e&"
import script from "./FeesTables.vue?vue&type=script&lang=js&"
export * from "./FeesTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports